import React, { useEffect } from 'react';
import EmailInput from '../../../../shared/components/emailInput/emailInput';

import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useDispatch, useSelector } from 'react-redux';
import ACTIONS from '../../../../redux/action';
import axios from '../../../../shared/axios/axiosProxy';
import i18n from '../../../../utils/i18n';
import ContactFieldInput from '../contactPage/ContactFieldInput';

const buildCompanyCtcName = (lastName, firstName) => {
	const last = (lastName || '').trim();
	const first = (firstName || '').trim();
	if (!last && !first) return '';
	if (!last) return first;
	if (!first) return last;
	return `${last} ${first}`;
};

const ContactInfo = ({
	splitNameFields = false,
	layout = 'default',
	middleSlot = null,
	lastNameLabel,
	firstNameLabel,
	emailLabel,
	phoneLabel,
	className = '',
	...props
}) => {
	const isContactGrid = layout === 'contactGrid';
	const [email, setEmail] = React.useState('');
	const [phone, setPhone] = React.useState('');
	const [companyctcname, setCompanyCtcName] = React.useState('');
	const [contactLastName, setContactLastName] = React.useState('');
	const [contactFirstName, setContactFirstName] = React.useState('');
	const dispatch = useDispatch();
	const companyStore = useSelector((state) => state.company_store);

	const dataLayerUpdate = (stepData) => {
		window.dataLayer.push({
			event: 'sf_step_user_email',
			user_email: stepData,
		});
	};

	const updateSearchSchemaContact = ({ emailValue, nameValue, phoneValue }) => {
		if (companyStore.searchID) {
			const patchData = {};
			if (emailValue !== undefined) {
				patchData.email = emailValue;
			}
			if (nameValue !== undefined) {
				patchData.companyctcname = nameValue;
			}
			if (phoneValue !== undefined) {
				patchData.companyPhone = phoneValue;
			}

			if (Object.keys(patchData).length === 0) return;
			axios
				.patch(
					`/api/search/${companyStore.searchID}`,
					patchData,
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					// console.log('Contact data saved to searchSchema:', response.statusText);
				})
				.catch((error) => {
					console.error(
						'Error saving contact data to searchSchema:',
						error.response?.data || error.message
					);
				});
		}
	};

	useEffect(() => {
		setEmail(companyStore.email);
		setPhone(companyStore.companyPhone);
		if (splitNameFields) {
			const s = (companyStore.companyctcname || '').trim();
			const i = s.indexOf(' ');
			if (i === -1) {
				setContactLastName(s);
				setContactFirstName('');
			} else {
				setContactLastName(s.slice(0, i).trim());
				setContactFirstName(s.slice(i + 1).trim());
			}
		} else {
			setCompanyCtcName(companyStore.companyctcname);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const emailChangeHandler = (event) => {
		const emailValue = event.target.value;
		setEmail(emailValue);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'email',
				data: emailValue,
				stateObject: 'company_store',
			})
		);
	};
	const emailBlurHandler = (event) => {
		const emailValue = event.target.value;
		dataLayerUpdate(emailValue);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'email',
				data: emailValue,
				stateObject: 'company_store',
			})
		);
		updateSearchSchemaContact({ emailValue });
		props.onEmailBlur?.();
	};

	const lastNameChangeHandler = (event) => {
		const last = event.target.value;
		setContactLastName(last);
		const nameValue = buildCompanyCtcName(last, contactFirstName);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companyctcname',
				data: nameValue,
				stateObject: 'company_store',
			})
		);
	};
	const lastNameBlurHandler = (event) => {
		const last = event.target.value;
		setContactLastName(last);
		const nameValue = buildCompanyCtcName(last, contactFirstName);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companyctcname',
				data: nameValue,
				stateObject: 'company_store',
			})
		);
		updateSearchSchemaContact({ nameValue });
		props.onNameBlur?.();
	};
	const firstNameChangeHandler = (event) => {
		const first = event.target.value;
		setContactFirstName(first);
		const nameValue = buildCompanyCtcName(contactLastName, first);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companyctcname',
				data: nameValue,
				stateObject: 'company_store',
			})
		);
	};
	const firstNameBlurHandler = (event) => {
		const first = event.target.value;
		setContactFirstName(first);
		const nameValue = buildCompanyCtcName(contactLastName, first);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companyctcname',
				data: nameValue,
				stateObject: 'company_store',
			})
		);
		updateSearchSchemaContact({ nameValue });
		props.onNameBlur?.();
	};

	const emailField = (
		<div className="contactEmailField marginBot12">
			{isContactGrid ? (
				<ContactFieldInput
					id="email"
					name="email"
					type="email"
					disabled={companyStore.submitted}
					placeholder={i18n.t('searchflow.emailplaceholder')}
					value={email}
					onChange={emailChangeHandler}
					onBlur={emailBlurHandler}
					error={props.emailError}
					errorText={i18n.t('searchflow.emailerrortext')}
					label={emailLabel || i18n.t('searchflow.obligmaillabel')}
				/>
			) : (
				<EmailInput
					disabled={companyStore.submitted}
					onChange={emailChangeHandler}
					onBlur={emailBlurHandler}
					value={email}
					id="email"
					name="email"
					error={props.emailError}
					label={emailLabel || i18n.t('searchflow.obligmaillabel')}
				/>
			)}
			{!isContactGrid && props.emailError ? (
				<span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
					{i18n.t('searchflow.obligmailtext')}
				</span>
			) : null}
		</div>
	);

	const phoneField = (
		<div
			className={`contactPhoneField marginBot12${
				isContactGrid && props.phoneError ? ' hasError' : ''
			}`}
		>
			{isContactGrid ? (
				<label className="contactPhoneLabel" htmlFor="companyPhone">
					{phoneLabel || i18n.t('searchflow.phonelabel')}
				</label>
			) : null}
			<PhoneInput
				countryCodeEditable={!isContactGrid}
				inputProps={
					isContactGrid
						? { placeholder: '+36 30 123 4567', id: 'companyPhone', name: 'companyPhone' }
						: { placeholder: '+36 30 123 4567' }
				}
				placeholder={i18n.t('searchflow.phoneplaceholder')}
				country={i18n.t('searchflow.countryshort')}
				masks={{ hu: i18n.t('searchflow.phoneplaceholderdots') }}
				value={phone}
				preferredCountries={[i18n.t('searchflow.countryshort')]}
				specialLabel={isContactGrid ? '' : phoneLabel || i18n.t('searchflow.phonelabel')}
				onChange={(phone) => {
					setPhone(phone);
					dispatch(
						ACTIONS.addCompanyInfo({
							id: 'companyPhone',
							data: phone,
							stateObject: 'company_store',
						})
					);
				}}
				onBlur={() => {
					dispatch(
						ACTIONS.addCompanyInfo({
							id: 'companyPhone',
							data: phone,
							stateObject: 'company_store',
						})
					);
					updateSearchSchemaContact({ phoneValue: phone });
					props.onPhoneBlur?.();
				}}
			/>
			{isContactGrid ? (
				<p
					className={`contactFieldErrorText${
						props.phoneError ? ' contactFieldErrorTextVisible' : ''
					}`}>
					{i18n.t('searchflow.phoneerrortext')}
				</p>
			) : props.phoneError ? (
				<span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
					{i18n.t('searchflow.obligphonetext')}
				</span>
			) : null}
		</div>
	);

	return (
		<div
			className={`ContactInfoContainer${isContactGrid ? '' : ' ReqMessageText'}${
				isContactGrid ? ' contactGridLayout' : ''
			} ${className}`.trim()}>
			<div className="ContactNameInput marginBot12">
				{splitNameFields ? (
					<div
						className={isContactGrid ? 'contactNameRow' : undefined}
						style={
							isContactGrid
								? undefined
								: {
										display: 'flex',
										flexDirection: 'row',
										flexWrap: 'wrap',
										gap: 12,
									}
						}>
						{isContactGrid ? (
							<>
								<ContactFieldInput
									id="companyctclastname"
									name="companyctclastname"
									disabled={companyStore.submitted}
									placeholder={i18n.t('searchflow.lastnameplaceholder')}
									value={contactLastName}
									onChange={lastNameChangeHandler}
									onBlur={lastNameBlurHandler}
									error={props.nameError && !contactLastName.trim()}
									errorText={i18n.t('searchflow.lastnameerrortext')}
									label={lastNameLabel || `${i18n.t('oneClick.lastNameLabel')} ${i18n.t('searchflow.requiredsuffix')}`}
								/>
								<ContactFieldInput
									id="companyctcfirstname"
									name="companyctcfirstname"
									disabled={companyStore.submitted}
									placeholder={i18n.t('searchflow.firstnameplaceholder')}
									value={contactFirstName}
									onChange={firstNameChangeHandler}
									onBlur={firstNameBlurHandler}
									error={props.nameError && !contactFirstName.trim()}
									errorText={i18n.t('searchflow.firstnameerrortext')}
									label={firstNameLabel || `${i18n.t('oneClick.firstNameLabel')} ${i18n.t('searchflow.requiredsuffix')}`}
								/>
							</>
						) : (
							<>
								<TextField
									disabled={companyStore.submitted}
									variant="outlined"
									sx={{ flex: '1 1 160px', minWidth: 0 }}
									onChange={lastNameChangeHandler}
									onBlur={lastNameBlurHandler}
									error={props.nameError}
									value={contactLastName}
									id="companyctclastname"
									name="companyctclastname"
									label={lastNameLabel || `${i18n.t('oneClick.lastNameLabel')} ${i18n.t('searchflow.requiredsuffix')}`}
								/>
								<TextField
									disabled={companyStore.submitted}
									variant="outlined"
									sx={{ flex: '1 1 160px', minWidth: 0 }}
									onChange={firstNameChangeHandler}
									onBlur={firstNameBlurHandler}
									error={props.nameError}
									value={contactFirstName}
									id="companyctcfirstname"
									name="companyctcfirstname"
									label={firstNameLabel || `${i18n.t('oneClick.firstNameLabel')} ${i18n.t('searchflow.requiredsuffix')}`}
								/>
							</>
						)}
					</div>
				) : (
					<TextField
						disabled={companyStore.submitted}
						onChange={(event) => {
							const nameValue = event.target.value;
							setCompanyCtcName(nameValue);
							dispatch(
								ACTIONS.addCompanyInfo({
									id: event.target.id,
									data: nameValue,
									stateObject: 'company_store',
								})
							);
						}}
						onBlur={(event) => {
							const nameValue = event.target.value;
							dispatch(
								ACTIONS.addCompanyInfo({
									id: event.target.id,
									data: nameValue,
									stateObject: 'company_store',
								})
							);
							updateSearchSchemaContact({ nameValue });
							props.onNameBlur?.();
						}}
						error={props.nameError}
						value={companyctcname}
						id="companyctcname"
						name="companyctcname"
						label={i18n.t('searchflow.oblignamelabel')}
					/>
				)}
				{!isContactGrid && props.nameError ? (
					<span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
						{i18n.t('searchflow.oblignametext')}
					</span>
				) : null}
			</div>
			<div className="ContactInfoInputs">
				{isContactGrid ? (
					<>
						{emailField}
						{middleSlot}
						{phoneField}
					</>
				) : (
					<>
						{emailField}
						{middleSlot}
						{phoneField}
					</>
				)}
			</div>
			{!isContactGrid && props.emailError ? (
				<p
					style={{
						color: 'red',
						fontSize: '14px',
						fontWeight: 'bold',
						margin: '8px 0px',
					}}>
					{i18n.t('searchflow.provideemail')}
				</p>
			) : null}
		</div>
	);
};

export default ContactInfo;
